import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getPrincipalMessage } from "../Service/Api";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Message = () => {
  const {
    data: principalData = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["principalMessage"],
    queryFn: async () => {
      const data = await getPrincipalMessage();
      return data;
    },
  });

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
  };

  const getDisplayCategory = (category) => {
    if (!category) return "";
    if (category.toLowerCase() === "vice principal") {
      return "Headmistress";
    }
    return category;
  };

  const categoryOrder = {
    Chairman: 1,
    Principal: 2,
    "Vice Principal": 3,
  };

  const slides = [];

  slides.push(
    <div key="founder">
      <div className="message-container">
        <div className="messageimg">
          <div className="testimonialimg">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/dummy1.png"
              alt="Frank Anthony"
              className="img-fluid"
            />
          </div>
          <div className="messageboximg">
            <p>
              Frank Anthony <span>Founder</span>
            </p>
          </div>
        </div>

        <div className="messagebox">
          <div className="col-lg-12">
            <h2>Our Founder</h2>
          </div>
          <div className="messagedesc">
            <div className="msginfo">
              <b>
                Frank Anthony Esq., 25th September, 1908 – 2nd December, 1993
              </b>
              <p>
                Mr. Frank Anthony had a versatile career and was a key figure in
                Anglo-Indian education in India. He was the founder chairman of
                the All-India Anglo-Indian Education Institution, which today
                manages several prestigious schools across India.
              </p>
            </div>
            <div className="mainbtn button readmorebtn">
              <Link to="/founder-inner">
                Read More <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>,
  );

  if (isLoading) {
    slides.push(
      <div key="loading" className="message-container text-center py-5">
        <p>Loading messages...</p>
      </div>,
    );
  } else if (isError) {
    slides.push(
      <div key="error" className="message-container text-center py-5">
        <p>Failed to load messages.</p>
      </div>,
    );
  } else {
    const sortedData = [...principalData]
      .filter((item) =>
        ["Chairman", "Principal", "Vice Principal"].includes(item.category),
      )
      .sort(
        (a, b) =>
          (categoryOrder[a.category] || 99) - (categoryOrder[b.category] || 99),
      );

    sortedData.forEach((item) => {
      const displayCategory = getDisplayCategory(item.category);

      slides.push(
        <div key={item._id}>
          <div className="message-container">
            <div className="messageimg">
              <div className="testimonialimg">
                <img
                  src={
                    item.attachments && item.attachments.length > 0
                      ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                      : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/dummy1.jpg"
                  }
                  alt={item.name}
                  className="img-fluid"
                />
              </div>
              <div className="messageboximg">
                <p>
                  {item.name} <span>{displayCategory}</span>
                </p>
              </div>
            </div>

            <div className="messagebox">
              <div className="messagedesc">
                <div className="msginfo">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.message || "",
                    }}
                  />
                </div>
                <div className="mainbtn button readmorebtn">
                  <Link
                    to={`/message/${displayCategory
                      .replace(/\s+/g, "-")
                      .toLowerCase()}`}
                  >
                    Read More <i className="bi bi-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>,
      );
    });
  }

  return (
    <div className="message-slider">
      <Slider {...settings}>{slides}</Slider>
    </div>
  );
};

export default Message;
